import React, { memo } from 'react';
import { Container, Grid } from '@mui/material';

import footerLogo from "../../../assets/images/FareTrack-Rebranding.logo.webp"
import { FOOTER_CONSTANTS } from '../../../utils/constants/footerConstants';
import LinkField from '../../common/links/linkField';
import "./footer.scss";
import { isValue } from '../../../utils/constants/constants';
import { useState } from 'react';
import moment from 'moment';

const Footer = () => {

    const [openSubMenu, setOpenSubMenu] = useState(false);
    const currentYear = moment().year();
    const handleSubMenuOpen = () => {
        setOpenSubMenu(!openSubMenu)
    }
    return (
        <div className="footer-section">
            <div className="footer-background">
                <Container>
                    <Grid container columns={{ xs: 4, sm: 6, md: 12 }}>
                        <Grid item xs={3}>
                            <div>
                                <img src={footerLogo} alt="FareTrack Logo" width="199.5" height="55.86" />
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <p className="foo-address-cs">Site Links</p>
                            <ul>
                                {FOOTER_CONSTANTS.PAGE_LINKS.map((page, index) =>
                                    page?.link ?
                                        <li key={index} >
                                            <LinkField link={page?.link} name={page?.name} arialabel={page?.arialabel ? page?.arialabel : isValue?.emptyString} rel={page?.rel ? page?.rel : isValue?.emptyString} title={page?.title ? page?.title : isValue?.emptyString} />
                                        </li>
                                        :
                                        <li key={index}>
                                            <LinkField name={page?.name} handleSubMenuOpen={handleSubMenuOpen} arialabel={page?.arialabel ? page?.arialabel : isValue?.emptyString} rel={page?.rel ? page?.rel : isValue?.emptyString} title={page?.title ? page?.title : isValue?.emptyString} />
                                            {!!openSubMenu &&
                                                <ul className="dropdown-content-cs">
                                                    {page?.childlink?.map((res, indx) =>
                                                        <li key={indx}>
                                                            <LinkField submenu={true} link={res?.link} name={res?.name} arialabel={res?.arialabel ? res?.arialabel : isValue?.emptyString} rel={res?.rel ? res?.rel : isValue?.emptyString} title={res?.title ? res?.title : isValue?.emptyString} />
                                                        </li>)

                                                    }
                                                </ul>
                                            }
                                        </li>

                                )}
                            </ul>
                        </Grid>
                        <Grid item xs={3}>
                            <ul>
                                {FOOTER_CONSTANTS.TERMS_LINKS.map((terms, index) => <li key={index}>
                                    <LinkField link={terms.link} name={terms.name} />
                                </li>)}
                            </ul>
                        </Grid>
                        <Grid item xs={3} className="address">
                            <ul className="socialicon">
                                <li><a href="https://twitter.com/FareTrack" aria-label="Twitter" rel="noopener noreferrer" title="Twitter" target="_blank"><img src="https://sandbox.faretrack.ai/wp-content/uploads/2024/05/Frame-5.png" alt="twitter" width="44" height="45" /></a></li>
                                <li><a href="https://www.linkedin.com/showcase/faretrack" aria-label="Linkedin" rel="noopener noreferrer" title="Linkedin" target="_blank"><img src="https://sandbox.faretrack.ai/wp-content/uploads/2024/05/Frame-4.png" alt="Linkedin" width="44" height="45" /></a></li>
                            </ul>
                            <p className="foo-address-cs">Address</p>
                            <p>
                                <img src="https://www.faretrack.ai/wp-content/uploads/2024/05/mingcute_location-line.png" className="locationi" alt="Location" width="19" height="19" />
                                <span>615 Griswold St, Suite 520, Detroit MI 48226</span>
                            </p>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <Container className="footer-background">
                <div className="copyright">
                    <p>© Copyright {currentYear} FareTrack - All Rights Reserved.</p>
                </div>
            </Container>
        </div>
    )
}

export default memo(Footer)